import {Deserializable} from '../deserializable';
import {YeuCauFile} from '../yeucau/yeucaufile';
import {ThongBaoFile} from './thongbaofile';
import {Staffs} from '../staff/staffs';
import {LoaiKeHoach} from '../danhmuc/loaikehoach';


export  class ThongBao implements Deserializable
{
  public id: number;
  public chuDe: string;
  public noiDung: string;
  public ngayNhap: string;
  public ngayHieuLuc: string;
  public gioHieuLuc: string;
  public ngayHetHieuLuc: string;
  public nguoiNhap: number;
  public soLuotDoc: number;
  public phoCap: number;
  public nguoiNhapItem: Staffs;
  public  thongBaoFiles: ThongBaoFile[];
  deserialize(input: any): this {
    Object.assign(this, input);
    this.nguoiNhapItem = input.nguoiNhapItem!= null? new Staffs().deserialize(input.nguoiNhapItem): null;
    this.thongBaoFiles = input.thongBaoFiles.map(thongBaoFiles => new ThongBaoFile().deserialize(thongBaoFiles));
    return this;
  }
}
